import { Box, Button, Link, Stack, Typography } from "@mui/material";
import { ReactComponent as RightArrowIcon } from "../../../assets/right-arrow.svg";
// import { usePoolDetails } from "../../../context/PoolDetails";
import useResponsive from "../../../hooks/useResponsive";
import { forwardRef } from "react";

export const EmptyRecommendationBox = forwardRef((props, ref) => {
  // const { degreesPower } = usePoolDetails();
  const degreesPower = { small: 5.0 }; // Placeholder for the degreesPower value
  const { isSm, isXs } = useResponsive();
  const RecommendationRef = ref; // Usar a ref passada ou criar uma ref interna
  const isMobile = isSm || isXs;

  const Buttons = () => (
    <Stack
      mt={isMobile ? 0 : 10}
      flexDirection={isMobile ? "column" : "row"}
      py={isMobile ? 8 : 0}
      gap={5}
    >
      <Link
        underline="none"
        color={"#000"}
        href="https://daveywater.com/au/support/contact-us/"
      >
        <Button
          startIcon={<RightArrowIcon />}
          variant="contained"
          fullWidth
          style={{
            height: "40px",
            display: " flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          Contact Us
        </Button>
      </Link>
      {isMobile && (
        <Button
          startIcon={<RightArrowIcon />}
          variant="contained"
          // onClick={() => setStep(1)}
        >
          Start Over
        </Button>
      )}
    </Stack>
  );

  return (
    <Box
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      height={"100%"}
      flexDirection={"column"}
      mt={isMobile ? 0 : 10}
      px={isMobile ? 2 : 0}
    >
      <Box
        p={isMobile ? 10 : 10}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        width={"100%"}
        ref={RecommendationRef} // Aplicar a ref
        flexDirection={"column"}
        sx={{ background: "#E4E4E4" }}
      >
        <Typography fontSize={isMobile ? 20 : 28} textAlign="center">
          According to the information you provided, our calculation shows
        </Typography>
        <Typography fontSize={isMobile ? 20 : 28} textAlign="center">
          {`that a minimum heat output of ${degreesPower.small.toFixed(
            2
          )} heat pump is needed. `}{" "}
        </Typography>
        <Typography fontSize={isMobile ? 20 : 28} textAlign="center">
          Unfortunately, we couldn't find a suitable heat pump for your pool,
          and it may require multiple units.
        </Typography>
        <Typography fontSize={isMobile ? 20 : 28} textAlign="center">
          Please contact your nearest Davey dealer or Davey Customer Care
        </Typography>
        <Typography fontSize={isMobile ? 20 : 28} textAlign="center">
          for further assistance in maintaining your pool's comfort.
        </Typography>

        {!isMobile && <Buttons />}
      </Box>

      {isMobile && <Buttons />}
    </Box>
  );
});
